// libs
import { ThunkAction } from 'redux-thunk'

// interfaces / constants
import { IAction } from 'src/actions/'
import { IUpdatebleUserProfile, IUser } from 'src/interfaces/user'
import { IRootState } from 'src/reducers/interface'

// helpers
import { AuthenticationHelper } from 'src/utils/authentication/authentication'
import { removeItem, setItem } from 'src/utils/storage_wrapper/storage_wrapper'
import { UrlUtils } from 'src/utils/url/url'
import { LAST_SELECTED_PROFILE_ID_STORAGE_KEY } from '../../utils/location_storage/location_storage'

export const USER_ME_REQUEST_SUCCESS = 'USER_ME_REQUEST_SUCCESS'
export const USER_ME_REQUEST_ERROR = 'USER_ME_REQUEST_ERROR'
export const USER_UPDATE_SELECTED_PROFILE = 'USER_UPDATE_SELECTED_PROFILE'
export const USER_REMOVE_PROFILE = 'USER_REMOVE_PROFILE'
export const USER_SET_SELECTED_PROFILE = 'USER_SET_SELECTED_PROFILE'

export interface IUserMeRequestSuccessAction {
  type: typeof USER_ME_REQUEST_SUCCESS;
  payload: IUser;
}

export interface IUserMeRequestErrorAction {
  type: typeof USER_ME_REQUEST_ERROR;
}

export interface IUpdateSelectedProfileAction {
  type: typeof USER_UPDATE_SELECTED_PROFILE;
  payload: IUpdatebleUserProfile;
}

export interface ISetSelectedProfileAction {
  type: typeof USER_SET_SELECTED_PROFILE;
  payload: string;
}

export interface IRemoveProfileAction {
  type: typeof USER_REMOVE_PROFILE;
  payload: string;
}

export const logOut = () => {
  return () => {
    AuthenticationHelper.logout()
    removeItem(LAST_SELECTED_PROFILE_ID_STORAGE_KEY)
    UrlUtils.setLocationHref('/')
  }
}

export const getMe =
  (identifier?: string): ThunkAction<void, IRootState, unknown, IAction> =>
    () => {
      if (identifier) {
        setItem(LAST_SELECTED_PROFILE_ID_STORAGE_KEY, identifier)
      }
    }

export const updateSelectedProfile = (
  userProfile: IUpdatebleUserProfile
): IUpdateSelectedProfileAction => ({
  payload: userProfile,
  type: USER_UPDATE_SELECTED_PROFILE
})

export const removeUserProfile = (profileId: string): IRemoveProfileAction => ({
  payload: profileId,
  type: USER_REMOVE_PROFILE
})

export const setSelectedProfile = (
  identifier: string
): ThunkAction<void, IRootState, unknown, IAction> => {
  return (dispatch) => {
    dispatch({
      payload: identifier,
      type: USER_SET_SELECTED_PROFILE
    })
  }
}
